module.exports = __webpack_public_path__ + "img/starthouse_signaturemenu_image15.f6a8454b.jpg";